export default {
  'Home.AccountCodeLogin': 'Account verification code login',
  'Home.Pleaseenteryourphonenumberoremail':
    'Please enter your phone number or email',
  'Home.Pleaseenteryouraccount': 'Please enter your account',
  'Home.PleaseenteryourphonenumberoremailSure':
    'Please enter a valid phone or email',
  'Home.Pleaseentertheverificationcode': 'Please enter the verification code',
  'Home.PleaseentertheverificationcodeSure':
    'Please enter the correct verification code',
  'Home.PleaseCode': 'Please complete the verification',
  'Home.GetVerificationCode': 'Get code',
  'Home.Login&Register': 'Login & Register',
  'Home.AccountPasswordLogin': 'Password login',
  'Home.Pleaseenteryourpassword': 'Please enter the your password',
  'Home.Login': 'Login',
  'Home.Profile': 'Profile',

  'Home.BasicInformation': 'Basic information',
  'Home.AccountManagement': 'Account management',
  'Home.PhoneSettings': 'Phone settings',
  'Home.EmailSettings': 'Email Settings',
  'Home.ChangePassword': 'Change password',
  'Home.UserLogout': 'User logout',
  'Home.PhoneAccount': 'Phone account',
  'Home.EmailAccount': 'Email account',
  'Home.RealName': 'Name',
  'Home.Save': 'Save',
  'Home.SecurityAuthentication': 'Security verification',
  'Home.BindNewPhoneNumber': 'Bind new phone number',
  'Home.SendTip1':
    'Send verification code to {phone} for identity verification',
  'Home.Next': 'Next Step',
  'Home.SendTip2':
    'Send verification code to {email} for identity verification',
  'Home.BindNewEmail': 'Bind new email',
  'Home.SetNewPassword': 'Set new password',
  'Home.LogoutConfirmation': 'Confirm logoutn',
  'Home.Logout': 'Log out',

  'Home.Nosettings': 'No Settings available',
  'Home.Pleaseenteryourrealname': 'Please enter your name',
  'Home.Modifiedsuccessfully': 'Modification successfully',
  'Home.Binding': 'Bind',
  'Home.Pleaseenteryourphonenumber': 'Please enter your phone number',
  'Home.PleaseenteryourphonenumberSure': 'Please enter a valid phone number',
  'Home.PhoneTip1':
    'You have not bound a phone yet; please enter your phone number to bind',
  'Home.PhoneTip2': 'The phone number is already bound; please check',

  'Home.PhoneNumber': 'Phone number',
  'Home.Email': 'Email',
  'Home.Confirmmodifications': 'Confirm changes',
  'Home.Securityverification': 'Security check',
  'Home.Bind1': 'Bind new phone number',
  'Home.EmailTip1': 'The email is already bound; please check',
  'Home.EmailTip2':
    'You have not bound an email yet; please enter your email to bind',
  'Home.EmailTip3': 'Please enter your email',
  'Home.EmailTip4': 'Please enter a valid email',
  'Home.Password': 'Password',
  'Home.PasswordTip1':
    'Password must be 8 - 16 characters, with at least 2 of letters, numbers, or symbols',
  'Home.PasswordTip2':
    'Please enter a password: 8 - 16 characters with at least 2 of letters, numbers, or symbols',
  'Home.Confirmpassword': 'Confirm password',
  'Home.PasswordTip3': 'Please enter your password again',
  'Home.PasswordTip4': 'Passwords do not match',
  'Home.Tip1': 'Please note! Data cannot be recovered after logout.',
  'Home.Tip2': 'Confirm logout',
  userAccountVerifyRules:
    'Name length supports 1-64 characters. It cannot start or end with a space.',

  'Home.PasswordError10Times':
    'The password is incorrect many times, please contact the superior dealer to reset the password; or login through the verification code and change the password after logging in!',

  'Home.oldPasswordToNew': 'Change old password to new',
  'Home.codeToNew': 'Change password with verification code',
  'Home.Pleaseentertheoldpassword': 'Please enter the old password',
  'Home.Pleaseenterthenewpassword': 'Please enter a new password',
  'Home.PleaseenterthenewpasswordSure': 'Please enter a valid password',
  'Home.Pleaseenterthenewpasswordagain': 'Please re-enter the new password',
  'Home.PleaseenterthenewpasswordagainSure': 'The passwords do not match',
  'Home.WeakPasswordTip':
    'Password must contain at least one letter and one number, and be at least 8 characters long',
  'Home.oldPassword': 'Old password',
  'Home.newPassword': 'New password',
  'Home.confirmPassword': 'Confirm password',
  'Home.UpdateSuccess': 'Password updated successfully',
  'Home.PasswordError': 'The account or password is incorrect',
  'Home.ConfirmRequired': 'Please enter the confirm password',
  'Home.oldPasswordToLogOut': 'Log out with old password',
  'Home.CodeToLogOut': 'Log out with verification code',
  'Login.Agree': 'Please review and agree',
  'Login.AgreeError': 'Please agree to the terms first.',
};
